import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { BuildingClassService } from '@http/clients/building-class.service';
import { GenericDropdownComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../../base/form-editor-base';

@Component({
    selector: 'app-report-building-class-form-editor',
    templateUrl: './report-building-class-form-editor.component.html',
    styleUrls: ['./report-building-class-form-editor.component.scss'],
    providers: [createValueAccessorProvider(ReportBuildingClassFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent]
})
export class ReportBuildingClassFormEditorComponent extends FormEditorBase<number | null> implements OnInit {
    readonly = input<boolean>(false);
    labelText = input<string>('Class');
    placeholderText = input<string>('Select Class');

    private readonly buildingClassService = inject(BuildingClassService);

    async ngOnInit(): Promise<void> {
        const classes = await this.buildingClassService.getAll();
        this.items.set(classes);
    }

    selectedItem(): any | undefined {
        const items = this.selectedItems();
        return items && items.length > 0 ? items[0] : undefined;
    }

    onSelectedItemChange(item?: any): void {
        if (item) this.onSelectedItemsChange([item]);
        else this.onSelectedItemsChange([]);
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): number | null {
        const item = this.selectedItem();
        return item?.id ?? null;
    }

    protected override mapValueToSelectedItems(value: number | null): any[] {
        if (!value) return [];
        const items = this.items() ?? [];
        const found = items.find((item) => Number(item.id) === Number(value));
        return found ? [found] : [];
    }
}
